<script setup lang="ts">
import { useFormat } from '@/composables/format';
import { type LaunchCalendarProductModelModel } from '@/models/launch-calendar-product-model.model';
import LaunchCalendarProductModel from './launch-calendar-product-model.vue';

export interface Props {
  launchDate: string;
  productModels: LaunchCalendarProductModelModel;
}

const props = defineProps<Props>();
const { launchCalendarDateFormatter } = useFormat();
</script>

<template>
  <div class="timeline-item">
    <div class="timeline-line"></div>
    <div class="timeline-point"></div>

    <p class="launch-date">{{ launchCalendarDateFormatter(props.launchDate) }}</p>
    <launch-calendar-product-model
      v-for="productModelName in Object.keys(props.productModels)"
      :key="productModelName"
      :product-model-name="productModelName"
      :products="props.productModels[productModelName]">
    </launch-calendar-product-model>
  </div>
</template>

<style scoped lang="scss">
.timeline-item {
  max-width: 270px;
  width: 270px;

  // Horizontal scroll while centering the nested divs in a flex-box doesn't work well
  // This is a workaround until justify-content: safe center; is available in all browsers
  &:first-child {
    margin-left: auto;
  }

  &:last-child {
    margin-right: auto;

    .timeline-line {
      border: unset;
    }
  }

  &:only-child {
    .timeline-line {
      @extend .timeline-line;
    }
  }

  .launch-date {
    text-align: left;
  }

  .timeline-line {
    width: 100%;
    border-top: 1px solid #000;
    margin-left: 18px;
  }
}

.timeline-point {
  position: relative;
  width: 1px;
  background-color: #000;
  height: 15px;
  margin-left: 18px;
}
</style>
